(function() {
    'use strict';
    angular
        .module('jmrsignApp')
        .factory('DocumentVersion', DocumentVersion);

    DocumentVersion.$inject = ['$resource'];

    function DocumentVersion ($resource) {
        var resourceUrl =  'api/document-versions/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
                    }
                    return data;
                }
            },
            'update': { method:'PUT' }
        });
    }
})();
